import styled from 'styled-components';
import {BGImageCenter, LIGHT_GRAY2, mobileMedia, WHITE, BLACK, SKY_BLUE, scrollbar, desktopMedia, SHADOW_COLOR} from '../../globalVariables/GlobalVariables';
import {dFlexBetween, alignCenter, dFlex, flexColumn, justifyBetween} from '../../globalVariables/GlobalFlex';
import {btn} from '../button/btn/Btn.css';
import {popUpBody} from '../newPopup/mobilePopup/MobilePopup.css';
import zIndex from '../../globalVariables/zIndex';
import {Close} from '../close/Close.css';

const baseText = `
    color: ${BLACK};
    text-align: center;
    font-family: Assistant;
    font-style: normal;
`;

export const wrapper = styled.div`
    ${popUpBody}{    
        max-width: 680px;
        ${desktopMedia}{
            max-height: calc(100% - 200px);
        }
        ${mobileMedia}{
            ${justifyBetween}
            max-height: 85%;
        }
    }
`;

export const bottomWrapper = styled.div`
    position: absolute;
    padding-top: 40px;
    width: 100%;
    bottom: -580px;
    transition: all 300ms; 
    z-index: ${zIndex.basicModal};
    border-radius: 12px 12px 0px 0px;
    background-color: ${WHITE};
    box-shadow: 0px -4px 8px ${SHADOW_COLOR};
    left: 0;
    &.show{        
        bottom: 0px;
    }
    ${mobileMedia} {
        height: 560px;
        bottom: -560px;
        max-height: calc(100% - 50px);
    }
    ${Close}{
        position: absolute;
        inset-block-start: 20px;
        inset-inline-start: 20px;
    }
`;

export const content = styled.div`
    padding: 32px 24px 0 24px;
    position: relative;
    width: 100%;
    height: calc(100% - 130px);
    ${mobileMedia}{
        padding-top: 20px;
        height: calc(100% - 70px);
    }
    ${scrollbar}
`;

export const image = styled.div<{ $icon: string }>`
    ${p=>BGImageCenter(p.$icon, 'contain')};
    width: 230px;
    height: 190px;
    position: absolute;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    z-index: ${zIndex.baseRaised};
    ${mobileMedia}{
        top: -70px;
        width: 160px;
        height: 130px;
    }
`;

export const title = styled.div`
    ${baseText}
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 8px;
    line-height: 1.3;
    ${mobileMedia}{
        font-size: 20px;
    }
    white-space: pre-line;
`;

export const text = styled.div`
    ${baseText}
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 24px;
    line-height: 1.5;
    ${mobileMedia}{
        font-size: 14px;
    }
`;

export const boldText = styled.div`
    ${baseText}
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 24px;
`;

export const cardGrid = styled.div`
    ${dFlex}
    width: 100%;
    ${desktopMedia}{
        gap: 16px;
        ${scrollbar}
        padding-bottom: 20px;
    }
    ${mobileMedia}{
        ${flexColumn}
        gap: 12px;
        height: 100%;
        padding-bottom: 56px;
    }
`;

export const actions = styled.div`
    width: 100%;
    border-top: 1px solid ${LIGHT_GRAY2};
    ${dFlexBetween};
    ${alignCenter};
    background-color: ${WHITE};
    flex-shrink: 0;
    padding-inline: 24px;
    box-sizing: border-box;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    height: 70px;
    z-index: ${zIndex.baseHighest};
    ${btn}{
        margin: 0;
        padding: 12px 25px;
        font-weight: 700;
    }
    ${mobileMedia}{
        padding: 16px 8px;
        border-radius: 0;
    }
`;

export const link = styled.div`
    color: ${SKY_BLUE};
    font-size: 15px;
    text-align: right;
    text-decoration: underline;
    cursor: pointer;
    margin-right: 8px;
    white-space: nowrap;
    ${mobileMedia}{
        font-size: 14px;
    }
`;
